"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@/ui/ui");
const event_1 = require("@/common/event");
const hoverProvider_1 = require("@/ui/hoverWidget/hoverProvider");
require("./toggle.less");
const defaultOptions = {
    disabled: false,
    tooltipPosition: "bottom-right"
};
/** @see https://github.com/nocpiun/toggle */
class Toggle extends ui_1.Component {
    constructor(target, _options) {
        super(((0, jsx_runtime_1.jsxs)("div", { className: "toggle", children: [(0, jsx_runtime_1.jsx)("span", { className: "toggle-bar" }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-knob" })] })), target, defaultOptions, _options);
        // events
        this._onDidChange = new event_1.Emitter();
        this.isActive = false;
        this._tooltipWidget = null;
        if (this._options.disabled)
            this.disabled = this._options.disabled;
        if (this._options.defaultValue)
            this.setActive(true);
        if (this._options.id)
            this._element.id = this._options.id;
        this._register(this._onDidChange);
        this._element.addEventListener("click", () => {
            if (!this.disabled)
                this._toggle();
        });
        if (this._options.tooltip) {
            this._register(this.onHover(() => {
                const rect = this._element.getBoundingClientRect();
                this._tooltipWidget = hoverProvider_1.hoverProvider.createTextHoverWidget(this._options.tooltip, {
                    x: rect.left,
                    y: rect.top + rect.height,
                }, this._options.tooltipPosition);
            }));
            this._register(this.onUnhover(() => {
                hoverProvider_1.hoverProvider.clearHoverWidgets();
                this._tooltipWidget = null;
            }));
        }
    }
    _toggle() {
        this.setActive(!this.isActive);
        this._onDidChange.fire(this.isActive);
    }
    set disabled(disabled) {
        disabled
            ? this._element.classList.add("toggle-disabled")
            : this._element.classList.remove("toggle-disabled");
        this._options.disabled = disabled;
    }
    get disabled() {
        return this._options.disabled;
    }
    get id() {
        return this._options.id;
    }
    setActive(isActive) {
        this.isActive = isActive;
        if (this.isActive) {
            this._element.classList.add("toggle-active");
        }
        else {
            this._element.classList.remove("toggle-active");
        }
    }
    setTooltip(text) {
        this._options.tooltip = text;
        if (this._tooltipWidget)
            this._tooltipWidget.text = text;
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    dispose() {
        super.dispose();
        hoverProvider_1.hoverProvider.clearHoverWidgets();
        this._tooltipWidget = null;
    }
}
exports.Toggle = Toggle;
